<template>
  <div class="card">
    <div class="card-body" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <form @submit="submit" class="add-edit-form product-form">
              <div class="row">
                <div class="col-lg-6">
                  <label for>
                    <span>Music Title:</span>
                    <input v-model="music.title" type="text" class="form-control" />
                  </label>
                  <label for>
                    <span>Music Artist:</span>
                    <input v-model="music.artist" type="text" class="form-control" />
                  </label>
                  <label for>
                    <span>Music Duration:</span>
                    <input v-model="music.duration" type="text" class="form-control" />
                  </label>
                  <label for>
                    <span>Music Link:</span>
                    <input v-model="music.link" type="text" class="form-control" />
                  </label>
                  <label for>
                    <span>Music Audio file</span>
                    <section class="form-control replace" :class="{'d-none': !isObject(music.audio)}">
                      <input type="button" class="replace-btn" data-id="audio" value="Replace File">
                      <span>{{music.audio}}</span>
                    </section>
                    <input :class="{'d-none': isObject(music.audio)}" @change="onAudioFileChange($event, 'audio')" type="file" id="audio" class="form-control" />
                  </label>
                  <label for>
                    <span>Music Image</span>
                    <section class="form-control replace" :class="{'d-none': !isObject(music.image)}">
                      <input type="button" class="replace-btn" data-id="image" value="Replace File">
                      <span>{{music.image}}</span>
                    </section>
                    <input :class="{'d-none': isObject(music.image)}" @change="onFileChange($event, 'image')" type="file" id="image" class="form-control" />
                  </label>
                </div>
                <div class="col-lg-6">
                  <div class="thumbnail-display"></div>
                </div>
              </div>
              <div class="col-lg-12 d-flex justify-content-center mt-3">
                <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="btn btn-success">
                  <div v-if="this.$store.getters.apiStatus != 'loading'">{{toEdit ? 'Update' : 'Save'}}</div>
                  <div v-else class="loader"><Loader></Loader></div>
                </button>
              </div>
            </form>
          </div>
          <div class="col-lg-6"></div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import YoutubeMusic from '@/models/YoutubeMusic'
export default{
  name: 'YoutubeMusicForm',
  data () {
    return {
      music: new YoutubeMusic()
    }
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetchYoutubeMusic()
    }
    $('.thumbnail-display').click(function () {
      $('#thumbnail').click()
    })

    $(document).on('change', '#image', function () {
      if (event.target.files.length) { $('.thumbnail-display').css('background-image', 'url(' + window.URL.createObjectURL(event.target.files[0]) + ')') } else { $('.thumbnail-display').css('background-image', 'none') }
    })

    $('.card').on('click', '.replace-btn', function () {
      var id = $(this).attr('data-id')
      $('#' + id).click()
    })
  },
  methods: {
    fetchYoutubeMusic () {
      this.$store.dispatch('fetchYoutubeMusic', this.$route.params.id)
        .then((result) => {
          this.music = new YoutubeMusic(result.data.youtubeMusic)
          $('.thumbnail-display').css('background-image', 'url("' + this.music.imageUrl + '")')
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    },
    submit (event) {
      event.preventDefault()
      var music = this.music.getFormData()
      var functionName = 'createYoutubeMusic'
      var successText = 'created'
      if (this.toEdit) { functionName = 'editYoutubeMusic'; successText = 'edited' }
      this.$store.dispatch(functionName, music)
        .then(() => {
          this.$router.push('/youtube-music')
          this.$toast.success('Music ' + successText + ' successfully')
        })
        .catch((err) => {
          console.log(err.response)
          this.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
        })
    },
    onFileChange (e, index) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.music[index] = null
        index = null
      } else { this.music[index] = files[0] }
    },
    onAudioFileChange (e, index) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.music[index] = null
        index = null
      } else { this.music[index] = files[0] }
    },
    isObject (val) {
      if (this.toEdit && !(val === 'null' || val === '')) { return true }
      return (typeof val === 'object')
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 767px) {
  .cat-div {
    width: 100% !important;
  }
}
.thumbnail-display {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/YoutubeForm.vue